module.exports = __webpack_public_path__ + "img/0Q3A8622_L_Black_MockedUp.fee56fd3.jpg";